"use client";

import { ArrangementImage } from "./arrangement-image";
import type { ImageArrangementProps } from "./image-arrangement-types";

const SIMPLE_COLUMNS_GAP_CLASS = "gap-4";

interface SimpleColumnsImageArrangementProps
  extends Pick<
    ImageArrangementProps,
    "background" | "images" | "readMoreLabel" | "readMoreModalTitle"
  > {}

export function SimpleColumnsImageArrangement(
  props: Readonly<SimpleColumnsImageArrangementProps>
) {
  const leftColumnImages = props.images.filter((_, index) => index % 2 === 0);
  const rightColumnImages = props.images.filter((_, index) => index % 2 === 1);

  return (
    <div
      className={`flex ${SIMPLE_COLUMNS_GAP_CLASS}`}
      data-testid="image-arrangement-simple-columns-grid"
    >
      <div
        className={`flex min-w-0 flex-1 flex-col ${SIMPLE_COLUMNS_GAP_CLASS}`}
        data-testid="image-arrangement-simple-columns-column-left"
      >
        {leftColumnImages.map((image, index) => (
          <div
            data-testid="image-arrangement-simple-columns-item"
            key={`${image.src}-left-${index}`}
          >
            <ArrangementImage
              background={props.background}
              defaultAspectRatio="1:1"
              image={image}
              readMoreLabel={props.readMoreLabel}
              readMoreModalTitle={props.readMoreModalTitle}
              sizes="50vw"
            />
          </div>
        ))}
      </div>

      <div
        className={`flex min-w-0 flex-1 flex-col ${SIMPLE_COLUMNS_GAP_CLASS}`}
        data-testid="image-arrangement-simple-columns-column-right"
      >
        {rightColumnImages.map((image, index) => (
          <div
            data-testid="image-arrangement-simple-columns-item"
            key={`${image.src}-right-${index}`}
          >
            <ArrangementImage
              background={props.background}
              defaultAspectRatio="1:1"
              image={image}
              readMoreLabel={props.readMoreLabel}
              readMoreModalTitle={props.readMoreModalTitle}
              sizes="50vw"
            />
          </div>
        ))}
      </div>
    </div>
  );
}
